import React, { useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ImageWithSkeleton = ({
  src,
  srcSet,
  alt = "image",
  className = "",
  wrapperClassName = "",
  skeletonHeight = 240,
  imgStyle,
  loading = "lazy",
  onLoad,
  onError,
  ...rest
}) => {
  const imgRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const hasImage = Boolean(src || srcSet);

    if (!hasImage) {
      setIsLoaded(true);
      return undefined;
    }

    setIsLoaded(false);

    const frameId = requestAnimationFrame(() => {
      const img = imgRef.current;

      if (img?.complete) {
        setIsLoaded(true);
      }
    });

    return () => cancelAnimationFrame(frameId);
  }, [src, srcSet]);

  const handleLoad = (event) => {
    setIsLoaded(true);
    if (onLoad) onLoad(event);
  };

  const handleError = (event) => {
    setIsLoaded(true);
    if (onError) onError(event);
  };

  return (
    <div className={`image-skeleton-wrap ${wrapperClassName}`.trim()} aria-busy={!isLoaded}>
      {!isLoaded ? (
        <div className="image-skeleton-loader" style={{ minHeight: skeletonHeight }}>
          <Skeleton
            height="100%"
            className="image-skeleton"
          />
          <span className="image-skeleton-loader__shine" aria-hidden="true" />
        </div>
      ) : null}
      <img
        ref={imgRef}
        src={src}
        srcSet={srcSet}
        alt={alt}
        className={`${className} image-skeleton-img ${isLoaded ? "is-loaded" : ""}`.trim()}
        style={imgStyle}
        loading={loading}
        onLoad={handleLoad}
        onError={handleError}
        {...rest}
      />
    </div>
  );
};

export default ImageWithSkeleton;
